import { render, staticRenderFns } from "./CambioAsientoPasoZona.vue?vue&type=template&id=0fc880f4"
import script from "./CambioAsientoPasoZona.vue?vue&type=script&setup=true&lang=js"
export * from "./CambioAsientoPasoZona.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports